export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20atmosphere%20with%20warm%20red%20and%20orange%20abstract%20light%20streaks%20mysterious%20entertainment%20news%20backdrop%20cinematic%20moody%20lighting%20with%20subtle%20texture&width=1920&height=1080&seq=hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/90"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-400 border border-accent-500/40 rounded-full mb-6">
              🔥 全网黑料实时追踪
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              91吃瓜
              <br />
              <span className="text-accent-400">实锤曝光明星塌房</span>
            </h1>

            <p className="text-lg text-white/50 font-light mb-6">
              九一吃瓜网，独家深扒真相揭秘
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed mb-3 max-w-xl mx-auto lg:mx-0">
              全网黑料一网打尽，91吃瓜平台每日更新网红博主与校园素人最辣眼视频。吃瓜老家最新地址不变，从娱乐圈顶流到素人圈新瓜，我们坚持有锤放锤，每一篇爆料都有据可查。
            </p>
            <p className="text-sm md:text-base text-white/60 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              即刻吃瓜不错过任何爆点！当前热门专题覆盖明星塌房、网红翻车、素人爆料三大板块，每日更新量<span className="text-accent-400 font-medium"> 300+</span> 条独家内容。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-8 md:gap-12 mb-10">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-white">300+</p>
                <p className="text-xs text-white/50 mt-1">每日新料</p>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">明星/素人</p>
                <p className="text-xs text-white/50 mt-1">全面覆盖</p>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-white">免费实锤</p>
                <p className="text-xs text-white/50 mt-1">有据可查</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                className="group inline-flex items-center gap-2 px-7 py-3 bg-accent-500 text-background-50 font-medium text-sm rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <span className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center">
                  <i className="ri-fire-line text-sm"></i>
                </span>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="px-7 py-3 border border-white/30 text-white font-medium text-sm rounded-full hover:border-accent-400 hover:text-accent-400 transition-all whitespace-nowrap cursor-pointer"
              >
                我要投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end relative">
            <div className="relative w-72 md:w-80 lg:w-96 h-[480px] md:h-[540px]">
              <div className="absolute top-0 left-0 w-44 md:w-48 h-44 md:h-48 rounded-2xl overflow-hidden shadow-2xl z-20 border-2 border-white/10">
                <img
                  src="https://readdy.ai/api/search-image?query=breaking%20news%20paparazzi%20style%20photo%20of%20dramatic%20scene%20with%20warm%20red%20lighting%20dark%20moody%20atmosphere%20celebrity%20scandal%20vibe%20editorial%20photography&width=600&height=600&seq=hero-sm&orientation=squarish"
                  alt="爆料现场实拍"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-16 left-20 w-56 md:w-64 h-[360px] md:h-[400px] rounded-2xl overflow-hidden shadow-2xl z-10 border-2 border-white/10">
                <img
                  src="https://readdy.ai/api/search-image?query=dramatic%20celebrity%20scandal%20breaking%20news%20main%20visual%20with%20warm%20orange%20and%20red%20atmosphere%20mysterious%20silhouette%20cinematic%20lighting%20high%20contrast%20editorial%20portrait%20style&width=700&height=1000&seq=hero-lg&orientation=portrait"
                  alt="明星塌房主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-20 h-20 rounded-full bg-accent-500/20 blur-xl z-0"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}